import { Controller } from "@hotwired/stimulus"
import { setFloatValue } from "@lib/utils"

export default class extends Controller {

  static targets = ["tax", "net", "gross", "cost", "coefficient"]
  
  get taxValue() {
    if (!this.taxTarget?.value) return 0
    return parseFloat(this.taxTarget.value)
  }
  
  get taxRatio() {
    return 1 + this.taxValue / 100
  }
  
  get grossValue() {
    if (!this.grossTarget?.value) return 0
    return setFloatValue(this.grossTarget.value)
  }

  get costValue() {
    if (!this.costTarget?.value) return 0
    return setFloatValue(this.costTarget.value)
  }

  get coefficientValue() {
    if (!this.coefficientTarget?.value) return 1
    return setFloatValue(this.coefficientTarget.value)
  }

  get netValue() {
    if (this.hasCostTarget && this.hasCoefficientTarget) {
      return setFloatValue(this.costValue * this.coefficientValue)
    } else if (this.hasNetTarget) {
      return setFloatValue(this.netTarget.value)
    }
  }

  setNet() {
    if (!this.hasNetTarget) return
    this.netTarget.value = setFloatValue(this.grossValue / this.taxRatio)
  }
  
  setGross() {
    this.grossTarget.value = setFloatValue(this.netValue * this.taxRatio)
  }

  setCostFromGross() {
    if (!this.hasCostTarget || !this.hasCoefficientTarget) return
    const netValue = this.grossValue / this.taxRatio
    this.costTarget.value = setFloatValue(netValue / this.coefficientValue)
  }

  onCostChange() {
    this.setGross()
  }

  onCoefficientChange() {
    this.setGross()
  }

  onTaxChange() {
    this.setGross()
  }

  onGrossChange() {
    if (this.hasCostTarget && this.hasCoefficientTarget) {
      this.setCostFromGross()
    } else if (this.hasNetTarget) {
      this.setNet()
    }
  }
  
}
